"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBoundingClientRect = void 0;
var _plateCommon = require("@udecode/plate-common");
var _slate = require("slate");
var _mergeClientRects = require("./mergeClientRects");
var getBoundingClientRect = function getBoundingClientRect(editor, at) {
  var atRanges = function () {
    if (!at) return [editor.selection].filter(Boolean);
    var atArray = Array.isArray(at) && !_slate.Path.isPath(at) ? at : [at];
    return atArray.map(function (location) {
      return (0, _plateCommon.getRange)(editor, location);
    });
  }();
  var clientRects = atRanges.map(function (range) {
    var _toDOMRange;
    return (_toDOMRange = (0, _plateCommon.toDOMRange)(editor, range)) === null || _toDOMRange === void 0 ? void 0 : _toDOMRange.getBoundingClientRect();
  }).filter(Boolean);
  if (clientRects.length === 0) return undefined;
  return (0, _mergeClientRects.mergeClientRects)(clientRects);
};
exports.getBoundingClientRect = getBoundingClientRect;